<template>
  <page>
    <form>
                <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon>Date Range</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
      <v-card>
        <v-card-text>
            <message :messages="messages"></message>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <cal-picker v-model="form.fromDate" :label="labels.fromDate" v-validate="'required'" :data-vv-as="labels.fromDate" data-vv-name="fromDate" :error-messages="errors.collect('fromDate')"></cal-picker>
                </v-flex>
                <v-flex xs12 md6>
                  <cal-picker v-model="form.toDate" :label="labels.toDate" v-validate="toDateValidation" :data-vv-as="labels.toDate" data-vv-name="toDate" :error-messages="errors.collect('toDate')" :min="this.form.fromDate"></cal-picker>
                </v-flex>
              </v-layout>
            </v-container>
        </v-card-text>
      </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
                <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon>Selection Criteria</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
      <v-card>
        <v-card-text>
          <v-form>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                 <!-- Business Class -->
                <v-flex xs12 md12>
                  <v-text-field v-model="form.busCls" :label="labels.busCls" :error-messages="errors.collect('busCls')"
                  :data-vv-as="labels.busCls" data-vv-name="busCls" append-icon="mdi-magnify" @click:append="showBusClsHelpList = true" @click="showBusClsHelpList=true"
                  readonly v-validate="'required'"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <!-- Transaction Type -->
                <v-flex xs12 md6>
                  <v-autocomplete :items="tranTypeList" v-model="form.tranType" :label="labels.tranType" item-text="label" item-value="value"
                    data-vv-name="tranType" :data-vv-as="labels.tranType" :error-messages="errors.collect('tranType')" v-validate="'required'">
                  </v-autocomplete>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <!-- Policy Release Status -->
                <v-flex xs12 md6>
                  <v-autocomplete :items="polRelStatList" v-model="form.polRelStat" :label="labels.polRelStat" item-text="label" item-value="value"
                    data-vv-name="polRelStat" :data-vv-as="labels.polRelStat" :error-messages="errors.collect('polRelStat')" v-validate="'required'">
                  </v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
      <v-flex lg6 xs12>
        <v-checkbox dense v-model="form.printRptRunTime" :label="labels.printRptRunTime" data-vv-name="printRptRunTime" :data-vv-as="labels.printRptRunTime"></v-checkbox>
      </v-flex>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12 class="pt-3">
            <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
              <v-icon left dark>mdi-file-export</v-icon>
              {{labels.export}}
            </v-btn>
            <v-btn-toggle dense mandatory v-model="form.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{format.label}}</span>
                <v-icon :color="format.color">{{format.icon}}</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-flex>
        </v-layout>
      </v-container>
      <v-dialog v-model="showBusClsHelpList" width="900px" persistent>
        <multi-bus-cls-help-list :busCls="form.busCls" @close="doClose" @doAssign="doAssignBusCls($event)" />
      </v-dialog>
    </form>
  </page>
</template>

<script>

import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import clone from 'clone'
import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'
import MultiBusClsHelpList from '@/components/core/common/dialog/MultiBusClsHelpList.vue'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      labels: {
        fromDate: 'Transaction Date From*',
        toDate: ' Transaction Date To*',
        export: 'Export to',
        busCls: 'Business Classes',
        tranType: 'Transaction Type',
        polRelStat: 'Policy Release Status',
        printRptRunTime: 'Print Runtime Parameters'
      },
      form: {
        fromDate: '',
        toDate: '',
        format: 'XLSX',
        busCls: 'All',
        tranType: 'NR',
        polRelStat: 'T',
        printRptRunTime: true
      },
      menu: {},
      submitting: false,
      tranTypeList: [
        { label: 'New & Renewal', value: 'NR' },
        { label: 'New only', value: 'N' },
        { label: 'Renewal only', value: 'R' }
      ],
      polRelStatList: [
        { label: 'Released only', value: 'T' },
        { label: 'Unreleased only', value: 'F' },
        { label: 'Released & Unreleased', value: 'TF' }
      ],
      // HelpList
      showBusClsHelpList: false,
      panel: [0],
      panel2: [0]
    }
  },
  created() {
    this.$validator.extend('start_after_today', {
      getMessage(field, args) {
        return `The ${field} cannot be later than the date of application.`
      },
      validate(value, args) {
        if (value) {
          const today = removeTime(new Date())
          const tomorrow = new Date(today)
          tomorrow.setDate(tomorrow.getDate() + 1)
          const startDate = removeTime(value)
          // if (isAfter(today, startDate)) return false
          // else return true
          return (isAfter(tomorrow, startDate))
        } else return true
      }
    })
    this.doInit()
  },
  methods: {
    async doClose() {
      this.showBusClsHelpList = false
    },
    async doAssignBusCls(Obj) {
      this.form.busCls = ''
      this.form.busCls = Obj.finalSelectedItems.toString()
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          let clonedForm = clone(this.form)
          await this.$http.post(apiURI, clonedForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doInit() {
      this.setMenu()
    },
    async setMenu() {
      try {
        if (this.$store.state.reports.custom1Reports.init !== 1) {
          await this.$store.dispatch('custom1ReportsInit')
        }
        const apiURI = this.rptMenu.newRenewalPolicy
        const result = await this.$http.get(apiURI)
        if (result.data) {
          this.menu = extractMenu(result.data._links)
        }
      } catch (err) {
        const { data } = err.response
        if (data) {
          this.message(data)
          this.fieldMessage(data)
        }
      }
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.custom1Reports.menu
    },
    supportedList() {
      const result = []
      result.push(reportFormat.XLSX)
      return result
    },
    toDateValidation() {
      const result = 'required|from_to_date:' + this.form.fromDate
      return result
    }
  },
  mixins: [
    MessageMixin
  ],
  components: {
    MultiBusClsHelpList
  }
}
</script>
